import React from 'react'
import { StyledColumn } from './_styled/column.styled'

const Column = ({ width, ...otherProps }) => (
  <StyledColumn px={2} width={[width]} {...otherProps} />
)

export default Column
